module.exports = __webpack_public_path__ + "img/uzbekistan.f0eb4284.svg";